import { useRouter } from 'next/navigation';
import Button from '../../atoms/Button';
import * as S from './styles';
import { IconeSeta } from '@/components/atoms/Icones/IconeSeta';
import Text from '@/components/atoms/Text';
import Avatar from '@/components/atoms/Avatar';
import { User } from 'next-auth';
import obterIniciaisNomeUsuario from '@/utils/obterIniciaisNomeUsuario';
import { useTheme } from 'styled-components';

export type HeaderMenuLateralLogadoProps = {
  $lidarMenuLateral: () => void;
  $usuarioLogado?: User;
};

export default function HeaderMenuLateralLogado(
  props: HeaderMenuLateralLogadoProps,
) {
  const { $lidarMenuLateral, $usuarioLogado } = props;
  const router = useRouter();
  const theme = useTheme();
  const usuarioPossuiImagem = !!$usuarioLogado?.image;

  return (
    <S.Container>
      <Avatar
        $size={5}
        $shape="rounded"
        $variant="solid"
        $color="accent"
        $image={$usuarioLogado?.image ?? undefined}
        $initials={
          !usuarioPossuiImagem
            ? obterIniciaisNomeUsuario($usuarioLogado?.name ?? '')
            : undefined
        }
        $initialsColor={
          !usuarioPossuiImagem ? theme.tokens.colors.black_contrast : undefined
        }
        $preencherFundo={!usuarioPossuiImagem ? true : undefined}
      />
      <S.Coluna>
        <Text
          $size={4}
          $color="neutral"
          $weight="bold"
          $align="left"
          $highContrast={true}
          $text={$usuarioLogado?.name}
        />
        <Button
          $size={2}
          $variant="ghost"
          $color="accent"
          $highContrast={false}
          $loading={false}
          $focusRing={false}
          $text="Minha conta"
          $IconEnd={IconeSeta}
          $iconEndProps={{
            direcao: 'direita',
          }}
          $onClick={() => {
            $lidarMenuLateral();
            return router.push('/minha-conta', { scroll: true });
          }}
        />
      </S.Coluna>
    </S.Container>
  );
}
